'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useInteractionTagContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useInteractionTagContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useInteractionTagContextValues_unstable(state) {
    const { appearance, disabled, handleTagDismiss, handleTagSelect, interactionTagPrimaryId, selected, selectedValues, shape, size, value } = state;
    return {
        interactionTag: _react.useMemo(()=>({
                appearance,
                disabled,
                handleTagDismiss,
                handleTagSelect,
                interactionTagPrimaryId,
                selected,
                selectedValues,
                shape,
                size,
                value
            }), [
            appearance,
            disabled,
            handleTagDismiss,
            handleTagSelect,
            interactionTagPrimaryId,
            selected,
            selectedValues,
            shape,
            size,
            value
        ])
    };
}
